export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    close: '閉じる',
    downloadFailed: 'ダウンロードに失敗しました',
    requestFailed: 'リクエストに失敗しました',
    processing: '処理中',
    logout: 'ログアウト',
    login: 'ログイン',
    signup: 'アカウント登録',
    language: '言語',
    expand: '展開',
    collapse: '折りたたむ',
    buyNow: 'プランを選択',
    improve: '改善',
    upgrade: 'プランをアップグレード',
    search: '検索',
    newProject: '新規プロジェクト',
    view: '表示',
    open: '開く',
    noMore: 'これ以上データはありません',
    performTasks: '実行中のタスク：',
    account: 'アカウント',
    demo: 'デモ',
    contact: 'お問い合わせ',
    userManage: 'ユーザー管理',
    // テストパネル
    test: {
      title: 'テスト',
      expand: '展開',
      collapse: '折りたたむ',
      loginStatus: 'ログイン状態',
      subscriptionStatus: 'サブスクリプション',
      currentUser: '現在のユーザー',
      currentRole: '現在のロール',
      isAdmin: '管理者',
      adminPrivileges: '管理者権限',
      userType: 'ユーザータイプ',
      shortcuts: 'ショートカット',
      loggedIn: 'ログイン済み',
      notLoggedIn: '未ログイン',
      subscribed: '購読済み',
      notSubscribed: '未購読',
      yes: 'はい',
      no: 'いいえ',
      enabled: '有効',
      disabled: '無効',
      visitor: 'ビジター',
      trial: 'トライアル',
      paid: '有料ユーザー',
      orgAdmin: '組織管理者',
      toggleSub: 'サブスクリプション切替',
      toggleAdmin: '管理者権限切替',
      refresh: '更新'
    },
    // API エラーコード
    errorCodes: {
      server_error: 'サーバーエラー',
      param_empty: 'パラメーターは空にできません',
      unauthorized: '権限エラー',
      user_not_registered: 'ユーザーが登録されていません',
      user_exists: 'ユーザーは既に存在します',
      user_disabled: 'ユーザーは無効化されています',
      forbidden: '操作は禁止されています',
      user_quota_insufficient: 'ユーザー定員が不足しています',
      data_not_found: 'データが存在しません',
      data_exists: 'データは既に存在します',
      name_exists: '名前は既に存在します',
      project_id_empty: 'プロジェクトIDは空にできません',
      project_not_found: 'プロジェクトが存在しません',
      task_type_empty: 'タスクタイプは空にできません',
      project_file_name_empty: 'プロジェクトファイル名は空にできません',
      insufficient_space: '容量が不足しています',
      task_id_empty: 'タスクIDは空にできません',
      task_not_found: 'タスクが存在しません',
      task_name_empty: 'タスク名は空にできません',
      task_template_not_found: 'タスクテンプレートが存在しません',
      task_processing: 'タスクは処理中です',
      status_empty: '状態は空にできません',
      size_empty: 'サイズは空にできません',
      algorithm_id_empty: 'アルゴリズムIDは空にできません',
      input_param_empty: '入力パラメーターは空にできません',
      project_data_empty: 'プロジェクトデータは空にできません',
      file_upload_failed: 'ファイルのアップロードに失敗しました',
      file_size_empty: 'ファイルサイズは空にできません',
      user_has_org: 'ユーザーは既に組織に所属しています',
      billing_cycle_not_found: '課金サイクルが存在しません',
      parent_node_id_empty: '親ノードIDは空にできません',
      share_not_found: '共有されたコンテンツは既に存在しません。',
      share_expired: '共有されたコンテンツの有効期限が切れました。',
      share_requires_password: '共有コンテンツにはパスワードが必要です。',
      share_password_incorrect: '共有パスワードが間違っています',
      user_not_found: 'ユーザーが存在しません',
      username_exists: 'ユーザー名は既に存在します',
      login_failed: 'ログインに失敗しました',
      email_exists: 'メールアドレスは既に存在します',
      reg_email_sent: '登録メールが送信されました',
      password_incorrect: 'パスワードが間違っています',
    }
  },
  layout: {
    title: 'クラウドコンピューティングポータル',
  },
  pages: {
    dashboard: 'ダッシュボード',
    projects: 'プロジェクト',
    pipelines: 'パイプライン',
    tasks: 'タスク',
  },
  home: {
    hero: {
      titleAccent: 'SLAM クラウドコンピューティング + AEC',
      titleMain: 'ソリューション',
      subtitle: '手持ち型 LiGrip を提供し、データ取得、処理、3D 可視化までをつなぐ完全な AEC ワークフローを実現します。'
    },
    workflow: {
      kicker: '統合ワークフロー',
      title: '統合型 AEC データ協業プラットフォーム',
      description: '現場からクラウドへ、協業から意思決定へ。データの流れをよりスマートに、チーム連携をより効率的にします。',
      videoAlt: '統合ワークフロー デモ動画',
      playAlt: '動画を再生',
      pauseAlt: '動画を一時停止',
      cards: {
        integration: {
          title: '統合ワークフロー',
          description: 'モバイルアプリ + クラウドコンピューティング + AEC データ分析 + 共有をシームレスに統合。現場でのデータ取得、クラウドでの計算処理、専門分析、共同共有までを一気通貫でつなぎ、完全な意思決定チェーンを構築します。'
        },
        minimalist: {
          title: 'シンプル操作',
          description: 'ワンクリックアップロード、自動計算。複雑なトレーニングは不要です。LiShare から生データをアップロードするだけで、バックエンドが自動処理を行い、チームは本来の業務に集中できます。'
        },
        collaboration: {
          title: 'チームコラボレーション',
          description: '複数ユーザーによるリアルタイムのオンライン協業と注記に対応。モデルや図面へ同時にコメントを付け、タスクを割り当て、フィードバックを即時同期できます。'
        },
        analysis: {
          title: 'データ分析とレポート出力',
          description: '強力な注記・計測ツールを内蔵し、さまざまな AEC シーンに対応します。PDF や Excel などの標準化レポートをワンクリックで生成し、報告や意思決定を強力に支援します。'
        },
        deployment: {
          title: 'オンプレミス導入',
          description: '自社サーバーへの導入を支援し、データを完全に自律管理できます。高いセキュリティ水準と業界コンプライアンス要件を満たし、重要資産やプロジェクトデータの漏えいを防ぎます。'
        },
        security: {
          title: 'データセキュリティとプライバシー',
          description: 'LiShare は ISO 27001 + ISO 27701 の二重認証を取得しています。技術、プロセス、管理の各レイヤーからデータとプライバシーを守り、事業全体を包括的に保護します。'
        }
      }
    },
    pricing: {
      title: '料金',
      currency: 'CHF',
      period: '/月',
      billing: {
        monthly: '月額請求、',
        yearly: '年額請求、',
        threeYears: '3 年ごとの請求、'
      },
      taxText: '税別',
      popular: '最も人気',
      tabs: {
        monthly: '月額',
        yearly: '年額',
        yearlyBadge: '17% 節約',
        threeYears: '3 年',
        threeYearsBadge: '44% 節約'
      },
      cta: {
        select: 'プランを選択',
        contact: '営業へ連絡'
      },
      plans: {
        starter: {
          name: 'Starter',
          summary: '簡単な共有、保存、処理に最適。個人ユーザー向けのベストプランです。',
          features: ['年間 500 FREE credits を含む', '無料セルフトレーニング']
        },
        pro: {
          name: 'Pro',
          summary: 'プロジェクト追跡、高度な処理オプション、簡単な共有を備えた、中小規模の専門チーム向けプランです。',
          features: ['年間 2,500 FREE credits を含む', '無料セルフトレーニング']
        },
        team: {
          name: 'Team',
          summary: '共有ワークスペース、権限制御、より高い処理容量が必要な協業チーム向けです。',
          features: ['年間 1,200 FREE credits を含む', '共有チームワークスペース']
        },
        business: {
          name: 'Business',
          summary: '複数プロジェクトを同時に進める業務チーム向けに、高い利用枠と柔軟な協業機能を提供します。',
          features: ['年間 5,000 FREE credits を含む', '優先処理とプロジェクト管理']
        },
        enterprise: {
          name: 'Enterprise',
          summary: '高度なチーム権限管理とサードパーティ連携に対応し、高い拡張性が必要な大規模組織向けです。',
          customLabel: 'カスタム価格',
          customPrice: 'お問い合わせください'
        }
      }
    },
    footer: {
      brand: 'Cloud-SLAM',
      description: '統合型 SLAM + クラウドコンピューティングソリューションの提供者として、先進的な空間認識技術とクラウドコンピューティングを組み合わせ、効率的で使いやすい 3D デジタルツールを提供します。',
      contactTitle: 'お問い合わせ：',
      address: '729 Heinz Avenue, Suite 9, Berkeley, California 94710, USA',
      phone: '400-009-9312',
      email: 'contact@cloud-slam.com',
      time: '月曜日〜金曜日、9:00–18:00'
    }
  },
  paymentSuccess: {
    iconAlt: '支払い完了',
    title: 'ご注文のお支払いが完了しました',
    orderNumber: '注文番号：',
    orderTime: '注文日時：',
    orderAmount: '注文金額：',
    billingCycle: '請求周期：',
    amountPrefix: 'USD $',
    action: '注文を確認して請求書を発行',
    placeholder: 'XXXXXXXXXXXXXXXXX',
    intervalUnit: {
      DAY: '日次',
      MONTH: '月次',
      YEAR: '年次',
    },
  },
  paymentFailed: {
    iconAlt: '支払い失敗',
    title: 'お支払いは中断されました',
    orderNumber: '注文番号：',
    orderTime: '注文日時：',
    backToStore: 'ホームに戻る',
    continueToPay: 'PayPal で支払いを続ける',
    amountPrefix: 'USD $',
    amountPlaceholder: 'USD $',
    placeholder: 'XXXXXXXXXXXXXXXXX',
  },
  projectManage: {
    deleteTitle: '削除の確認',
    deletePrompt: 'プロジェクト「{name}」のすべてのデータを削除してもよろしいですか？',
    renameTitle: 'プロジェクト名の変更',
    projectNameLabel: 'プロジェクト名',
    projectNamePlaceholder: 'プロジェクト名を入力',
    newTitle: '新規プロジェクト',
    newPlaceholder: 'プロジェクト名を入力',
    loading: '読み込み中…',
    noData: 'データがありません',
    noMoreData: 'これ以上データはありません',
    // Messages
    loadListFailed: 'プロジェクト一覧の読み込みに失敗しました',
    pleaseEnterName: 'プロジェクト名を入力してください',
    nameLengthInvalid: 'プロジェクト名は 2〜20 文字である必要があります',
    createSuccess: 'プロジェクトを作成しました',
    deleteSuccess: 'プロジェクトを削除しました',
    renameSuccess: 'プロジェクト名を変更しました'
  },
  engineeringManage: {
    pageTitle: 'プロジェクト管理',
    backHome: '前のページに戻る',
    uploadData: 'データをアップロード',
    projectIdLabel: 'プロジェクト ID',
    defaultProjectTitle: 'ソフトウェア新城測量プロジェクト',
    tableName: '名称',
    tableCreationTime: '作成日時',
    tableAlgorithm: 'タイプ',
    tableSize: 'サイズ',
    tableState: 'ステータス',
    tableOperation: '操作',
    statusFilterPlaceholder: 'ステータスで絞り込み',
    statusAll: 'すべてのステータス',
    statusOptions: {
      failed: '失敗',
      running: '実行中',
      success: '完了',
      init: '初期化中',
      uploading: 'アップロード中',
      upload_success: 'アップロード完了',
      wait_process: 'キュー待ち',
      upload_fail: 'アップロード失敗',
    },
    noData: 'データがありません',
    previous: '前へ',
    next: '次へ',
    operationPending: '現在利用できません',
    uploadPending: '現在利用できません',
    actionLog: 'ログ',
    actionFeedback: 'フィードバック',
    actionExport: 'レポートプレビュー',
    actionContact: 'お問い合わせ',
    actionDownload: 'ダウンロード',
    actionDelete: '削除',
    stateInit: '初期化中',
    stateUploading: 'アップロード中',
    stateFailed: '失敗',
    stateUploadSuccess: 'アップロード完了',
    stateWaitProcess: 'キュー待ち',
    stateUploadFail: 'アップロード失敗',
    stateRunning: '実行中',
    stateSuccess: '完了',
    deleteTitle: '削除の確認',
    deletePrompt: 'タスク「{name}」を削除してもよろしいですか？',
    deleteConfirm: 'タスク「{name}」を削除してもよろしいですか？',
    deleteSuccess: 'タスクを削除しました',
    deleteFailed: 'タスクの削除に失敗しました',
    feedbackSuccess: 'フィードバックを送信しました',
    downloadSuccess: 'ダウンロードを開始しました',
    noExportTypes: 'エクスポート可能な形式がありません',
    loadExportTypesFailed: 'エクスポート形式の取得に失敗しました',
    downloadFailed: 'ダウンロードに失敗しました',
    exportDataTitle: 'データをエクスポート',
    exportDataCancel: 'キャンセル',
    exportDataConfirm: '確認',
    exportDataOriginal: 'オリジナルデータ',
    fileFormatLiData: '点群データ',
    fileFormatGeojson: '軌跡データ',
    fileFormatPdf: 'レポート'
  },
  taskPanel: {
    projectName: '古木調査プロジェクト',
    projectDate: '2026年2月10日',
    eta: '残り予定時間 {time}',
    processing: '処理中',
    waiting: '待機中',
    error: 'エラー',
    statusFailed: '失敗',
    statusRunning: '実行中',
    statusSuccess: '完了',
    statusInit: '初期化中',
    statusUploading: 'アップロード中',
    statusUploadSuccess: 'アップロード完了',
    statusWaitProcess: 'キュー待ち',
    statusUploadFail: 'アップロード失敗',
    moveUp: '上へ移動',
    moveDown: '下へ移動',
    view: '表示',
    delete: '削除',
    taskIconAlt: 'タスク',
  },
  message: {
    loginLiShare: 'ログイン',
    loginAccount: 'アカウント',
    loginAccountPlaceholder: 'メールアドレスまたはユーザー名を入力',
    loginPassword: 'パスワード',
    loginPasswordPlaceholder: 'パスワードを入力',
    loginRememberMe: 'ログイン状態を保持',
    loginForgotPassword: 'パスワードをお忘れですか？',
    loginNewUser: '新規ユーザーですか？',
    loginButton: 'ログイン',
    loginRegister: 'アカウント登録',
    rememberMe: 'ログイン状態を保持',
    loginPhone: '電話番号でログイン',
    phone: '電話番号',
    loginPhonePlaceholder: '電話番号を入力',
    loginPhoneFormatPlaceholder: '正しい電話番号を入力してください',
    loginCodePlaceholder: '認証コードを入力',
    loginSuccess: 'ログインしました',
    loginFailed: 'ログインに失敗しました。電話番号と認証コードを確認してください。',
    loginRegisterSameAgreeTerms: '利用規約とプライバシーポリシーに同意してください',
    loginCode: '認証コード',
    loginSendCode: '送信',
    loginSendCodeSuccess: '認証コードを送信しました',
    loginSendCodeFailed: '認証コードの送信に失敗しました',
    loginBeian: '京ICP備13007633号-2',
    loginBeianNumber: '京公網安備 11010802026375号',
    loginEmail: 'メールアドレス',
    loginEmailPlaceholder: 'メールアドレスを入力',
    loginSubmit: '送信',
    loginUsername: 'ユーザー名',
    loginRegister: 'アカウント登録',
    loginCompany: '会社名',
    loginCompanyPlaceholder: '会社名を入力',
    loginPassword: 'パスワード',
    loginRegisterPassword: 'パスワードを入力',
    loginConfirmPassword: 'パスワードを確認',
    loginConfirmPasswordPlaceholder: 'パスワードを確認してください',
    loginRegisterPasswordPlaceholder: 'パスワードを入力してください',
    loginRegisterConfirmPassword: 'パスワードを確認',
    loginRegisterConfirmPasswordPlaceholder: 'パスワードを確認してください',
    loginRegisterIndustry: '業種',
    loginRegisterIndustryPlaceholder: '業種を選択してください',
    loginRegisterIndustryFailed: '業種リストの取得に失敗しました。後ほど再度お試しください。',
    loginRegisterPhone: '電話番号',
    loginRegisterPhonePlaceholder: '電話番号を入力してください',
    loginRegisterSamePhoneFormat: '正しい電話番号を入力してください',
    loginRegisterButton: '登録',
    loginRegisterSamePassword: 'パスワードが一致しません',
    loginRegisterSamePasswordFailed: 'パスワードが一致しません',
    loginRegisterSameAccount: 'アカウントは既に存在します',
    loginRegisterSameAccountFailed: 'アカウントが存在しません',
    loginRegisterSamePhone: '電話番号は既に登録されています',
    loginRegisterSamePhoneFailed: '電話番号が存在しません',
    loginRegisterSameEmail: 'メールアドレスは既に登録されています',
    loginRegisterSameEmailFailed: 'メールアドレスが存在しません',
    loginRegisterSameCode: '認証コードが正しくありません',
    loginRegisterSameCodeFailed: '認証コードが正しいです',
    loginRegisterSameAccountLength: 'アカウント名は 3〜20 文字である必要があります',
    loginUsernameFormat: 'ユーザー名は 3〜20 文字の英字、数字、アンダースコア、または有効なメールアドレスである必要があります',
    loginCompanyNameLength: '会社名は 2〜20 文字である必要があります',
    loginRegisterSamePasswordLength: 'パスワードは 6〜20 文字である必要があります',
    loginPasswordComplexity: 'パスワードは 6〜20 文字で、英字、数字、記号のうち少なくとも 2 種類を含める必要があります',
    loginRegisterSamePasswordConfirm: 'パスワードが一致しません',
    loginEmailFormatPlaceholder: '正しいメールアドレスを入力してください',
    loginSendCodeSuccess: '認証コードを送信しました。メールをご確認ください。',
    loginSendCodeFailed: '認証コードの送信に失敗しました。後ほど再度お試しください。',
    loginVerifyCodeFailed: '認証コードが正しくありません。確認して再度お試しください。',
    loginRegisterSamePhoneLength: '電話番号は 11 桁である必要があります',
    loginRegisterAgreeTerms: '以下の規約に同意します',
    loginRegisterTerms: '利用規約',
    loginRegisterGVITerms: 'GVI サービス規約',
    forgotPassword: 'パスワードをお忘れですか？',
    loginRegisterSameAccountTip: '既にアカウントをお持ちですか？',
    loginRegisterFailed: '登録に失敗しました。後ほど再度お試しください。',
    loginNewPassword: '新しいパスワード',
    loginNewPasswordPlaceholder: '新しいパスワードを入力',
    loginConfirmNewPassword: '新しいパスワードを確認',
    loginConfirmNewPasswordPlaceholder: '新しいパスワードを確認してください',
    loginResetSuccess: 'パスワードをリセットしました。ログインしてください。',
    loginResetFailed: 'パスワードのリセットに失敗しました。後ほど再度お試しください。',
    sharePasswordInvalid: '共有パスワードは 4〜6 文字で、数字または英字のみ使用できます',

    // Signup
    signup: {
      createAnAccount: 'アカウントを作成',
      fullName: 'アカウント名',
      enterFullName: 'アカウント名を入力してください',
      emailAddress: 'メールアドレス',
      enterEmailAddress: '正しいメールアドレスを入力してください',
      company: '会社名',
      pLcompany: '会社名を入力してください',
      password: 'パスワード',
      confirmPassword: 'パスワードを確認',
      industry: '業種',
      industryInput: '少なくとも 1 つ選択してください',
      readAgree: '以下の規約を読み、同意します',
      terms: '利用規約',
      GVI: 'GVI サービス規約',
      remember: '規約に同意してください',
      createAccount: 'アカウントを作成',
      haveAccount: '既にアカウントをお持ちですか？',
      successfullySentEmail: '登録メールを送信しました。メールをご確認ください。',
      failedToSendEmail: '登録メールの送信に失敗しました',
      goToDashboard: 'ダッシュボードへ',
      status: {
        industryInput: '少なくとも 1 つ選択してください',
        zcsucceeded: '登録が完了しました',
      },
      emailAlreadyInUse: 'このメールアドレスは既に登録されています',
      fullNameAlreadyInUse: 'このアカウント名は既に登録されています',
      new_password: {
        login: 'ログイン',
      },
    },

    // Forgot Password
    forgotPasswordTitle: 'パスワードを忘れた場合',
    email: 'メールアドレス',
    pleaseEnterEmail: 'メールアドレスを入力してください',
    submit: '送信',
    phoneNumber: '電話番号',
    pleaseEnterPhoneNumber: '電話番号を入力してください',
    sendCode: '認証コードを送信',
    resendCode: '再送信',
    sendCodeSuccess: '認証コードを送信しました',
    newPassword: '新しいパスワード',
    pleaseEnterNewPassword: '新しいパスワードを入力してください',
    confirmNewPassword: 'パスワードを確認',
    pleaseConfirmNewPassword: 'パスワードを確認してください',
    passwordNotMatch: 'パスワードが一致しません',
    emailSentSuccess: 'メールを送信しました',
    backToLogin: 'ログインに戻る',
    codeSentToEmail: 'リセットリンクをメールで送信しました',
    clickLinkInEmail: 'メール内のリンクをクリックしてパスワードをリセットしてください',
    resetSuccess: 'パスワードをリセットしました',
    resetFailed: 'パスワードのリセットに失敗しました',

    add: '追加',
    edit: '編集',
    rename: '名前を変更',
    share: '共有',
    download: 'ダウンロード',
    detail: '詳細',
    projectRename: '名前を変更',
    update: '更新',
    delete: '削除',
    clear: 'クリア',
    ok: 'OK',
    sceneNoDataTitle: '注意',
    sceneNoPointCloudData: '現在のシーンには点群データがありません。',

    privacy: 'プライバシーポリシー',
    terms: '利用規約',
  },
  accountSetting: {
    title: 'アカウント設定',
    nicknameLabel: 'ユーザー名',
    avatarLabel: 'アバター',
    newPasswordLabel: '新しいパスワード',
    confirmNewPasswordLabel: '新しいパスワード（確認）',
    emailLabel: 'メールアドレス',
    emailSupportHint: 'メールアドレスの変更は GreenValley サポートへお問い合わせください。',
    companyLabel: '会社名',
    industryLabel: '業種',
    avatarImageOnly: '画像ファイルをアップロードしてください',
    avatarTooLarge: 'アバターのファイルサイズは 5 MB を超えることはできません',
    loadFailed: 'アカウント情報の読み込みに失敗しました',
    uploadSuccess: 'アバターをアップロードしました',
    uploadFailed: 'アバターのアップロードに失敗しました',
    updateSuccess: 'アカウント情報を更新しました',
    updateFailed: 'アカウント情報の更新に失敗しました',
    industryOptions: {
      surveyingMapping: '測量・地図作成',
      forestryEcology: '林業・生態学',
      smartCity: 'スマートシティ'
    },
    rules: {
      nicknameRequired: 'ユーザー名を入力してください',
      nicknameInvalid: 'ユーザー名は 3〜20 文字の英字、数字、アンダースコア、または有効なメールアドレスである必要があります',
      avatarRequired: 'アバターをアップロードしてください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '正しいメールアドレスを入力してください',
      newPasswordRequired: '新しいパスワードを入力してください',
      newPasswordInvalid: 'パスワードは 6〜20 文字で、英字、数字、記号のうち少なくとも 2 種類を含める必要があります',
      confirmNewPasswordRequired: '確認用のパスワードを入力してください',
      confirmNewPasswordMismatch: '新しいパスワードと確認用のパスワードが一致しません'
    }
  },
  userManage: {
    pageTitle: 'ユーザー管理',
    backHome: 'ホームに戻る',
    newUser: '新規ユーザー',
    loading: '読み込み中…',
    username: 'ユーザー名',
    usernameSearchPlaceholder: 'ユーザー名で検索',
    email: 'メールアドレス',
    effective: 'ステータス',
    lastLogin: '最終ログイン',
    operation: '操作',
    normal: '有効',
    disabled: '無効',
    view: '表示',
    edit: '編集',
    delete: '削除',
    previous: '前へ',
    next: '次へ',
    noData: 'ユーザーデータがありません',
    deleteConfirmTitle: 'ユーザー「{name}」を削除してもよろしいですか？',
    loadListFailed: 'ユーザー一覧の読み込みに失敗しました',
    createSuccess: 'ユーザーを作成しました',
    createFailed: 'ユーザーの作成に失敗しました',
    updateSuccess: 'ユーザーを更新しました',
    updateFailed: 'ユーザーの更新に失敗しました',
    deleteSuccess: 'ユーザーを削除しました',
    deleteFailed: 'ユーザーの削除に失敗しました',
    modal: {
      createTitle: 'ユーザーを作成',
      editTitle: 'ユーザーを編集',
      viewTitle: 'ユーザーを表示',
      usernameLabel: 'ユーザー名',
      usernamePlaceholder: 'ユーザー名を入力',
      emailLabel: 'メールアドレス',
      emailPlaceholder: 'メールアドレスを入力',
      effectiveLabel: 'ステータス',
      emailAction: 'メール操作',
      rules: {
        usernameRequired: 'ユーザー名を入力してください',
        usernameInvalid: 'ユーザー名は 3〜20 文字の英字、数字、アンダースコア、または有効なメールアドレスである必要があります',
        emailRequired: 'メールアドレスを入力してください',
        emailInvalid: '正しいメールアドレスを入力してください',
        effectiveRequired: 'ステータスを選択してください'
      }
    }
  },
  threeD: {
    layers: 'レイヤー',
    filterByNameAndTags: '名前とタグでフィルタ…',
    pointCloudLayers: '点群レイヤー',
    panoramicLayers: 'パノラマレイヤー',
    vectorLayers: 'ベクターレイヤー',
    annotationLayers: '注釈レイヤー',
    modelLayers: 'モデルレイヤー',
    gaussLayers: '3DGS レイヤー',
    obliquePhotographyLayers: '3D Tiles レイヤー',
    visibility: '表示',
    rename: '名前を変更',
    editStyle: 'スタイルを編集…',
    zoomToLayer: 'レイヤーにズーム',
    exportData: 'データをエクスポート…',
    delete: '削除',
    attributeTable: '属性テーブル',
    twoDView: '2D 表示',
    threeDView: '3D 表示',
    resetView: '表示をリセット',
    zoomToFullExtent: '全体を表示',
    pointAnnotation: 'ポイント注釈',
    lineAnnotation: 'ライン注釈',
    polygonAnnotation: 'ポリゴン注釈',
    measureDistance: '距離を測定',
    measureArea: '面積を測定',
    measureVolume: '体積を測定',
    profileAnalysis: '断面分析',
    modelClipping: 'モデルクリッピング',
    swipeComparison: 'スワイプ比較',
    shareView: '表示を共有',
    exportReport: 'レポートをエクスポート',
    createBookmark: 'ブックマークを作成',
    screenshot: 'スクリーンショット',
    settings: '設定',
    profileAnalysis: '断面分析',
    drawLineOnMapToGenerateProfile: '地図に線を描いて断面を生成',
    clippingTool: 'クリッピングツール',
    drawAPolygonToDefineClippingArea: 'ポリゴンを描いてクリッピング領域を定義',
    keepInside: '内側を保持',
    keepOutside: '外側を保持',
    clearClipping: 'クリッピングを解除',
    shareThisView: 'この表示を共有',
    shareableLink: '共有可能なリンク',
    setPasswordOptional: 'パスワードを設定（任意）',
    linkExpiresIn: 'リンクの有効期限',
    expirationDate: '有効期限',
    days: '日',
    generateQRCode: 'QR コードを生成',
    recipientsCanViewButCannotEdit: '受信者は表示できますが、編集はできません',
    distance: '距離',
    area: '面積',
    volume: '体積',
    plotting: '作図',
    profile: '断面',
    cModels: '切断モデル',
    sourceLayers: 'ソースレイヤー',
    profileTool: {
      defaultName: '断面 {count}',
      startPoint: '始点',
      endPoint: '終点',
      operationPreview: '操作プレビュー'
    },
    timeUnit: {
      year: '年',
      month: '月',
      day: '日',
      hour: '時'
    },
    untitledProject: '無題のプロジェクト',
    bookmarkSaved: 'ブックマークを保存しました',
    screenshotSaved: 'スクリーンショットをダウンロードフォルダに保存しました',
    screenshotFailed: 'スクリーンショットの保存に失敗しました',
    modeSwitch: {
      switchTo2D: '2D モードに切り替え',
      switchTo3D: '3D モードに切り替え',
      zoomIn: 'ズームイン',
      zoomOut: 'ズームアウト',
      resetView: '表示をリセット',
      roam: 'ローミング',
      pointTool: 'ポイントツール',
      lineTool: 'ラインツール',
      polygonTool: 'ポリゴンツール',
      circleTool: '円ツール',
      volumeTool: '体積ツール',
      profileTool: '断面ツール',
      cutModelTool: 'モデル切断ツール'
    },
    // UI组件相关
    systemSettings: {
      title: 'システム設定',
      backgroundColor: '背景色',
      spawnPointSettings: '出現点設定',
      setSpawnPoint: '出現点を設定',
      skybox: 'スカイボックス',
      light: 'ライト',
      black: 'ブラック',
      white: 'ホワイト',
      iconAlt: '設定アイコン'
    },
    shareSettings: {
      title: '共有設定',
      shareLink: '共有リンク',
      encryption: '暗号化',
      browserNotSupport: 'お使いのブラウザはクリップボード機能をサポートしていません',
      copySuccess: 'リンクをコピーしました',
      copyFailed: 'リンクのコピーに失敗しました',
      preview3D: '3D プレビュー',
      generatingQRCode: 'QR コードを生成中…',
      hours24: '24 時間',
      days7: '7 日',
      days14: '14 日',
      customize: 'カスタム',
      hour: '時間',
      day: '日',
      week: '週',
      month: '月',
      preview3D: '3D プレビュー',
      application: '適用',
      qrCode: 'QR コード',
      scanQRCode: 'QR コードをスキャン',
      copy: 'コピー',
      advanced: '詳細設定',
      validityPeriod: '有効期限',
      generatingQRCode: 'QR コードを生成中…',
      scanQRCode: 'QR コードをスキャン',
    },
    bottomToolbar: {
      share: '共有',
      export: 'エクスポート',
      compare: '比較',
      bookmark: 'ブックマーク',
      exportConfig: 'スクリーンショット',
      importConfig: '設定をインポート',
      exportPdfSuccess: 'レポートをエクスポートしました',
      exportPdfFailed: 'レポートのエクスポートに失敗しました',
      exportPdfNoTask: '先にタスクを選択してください',
    },
    pointCloudCompare: {
      title: '期間比較',
      unavailableTitle: '期間比較は利用できません',
      missingProjectId: 'プロジェクト ID が不足しています。',
      insufficientTasks: 'このプロジェクトには少なくとも 2 つのタスクが必要です。',
      syncCamera: '視点を同期',
      close: '閉じる',
      leftPeriod: '左側の期間',
      rightPeriod: '右側の期間',
    },
    bookmark: {
      title: 'ブックマーク',
      name: '名前',
      namePlaceholder: 'ブックマーク名を入力',
      description: '説明',
      descriptionPlaceholder: '説明を入力',
      save: '保存',
      cancel: 'キャンセル',
      edit: '編集',
      delete: '削除',
      loadFailed: 'ブックマークの読み込みに失敗しました',
      saveSuccess: 'ブックマークを保存しました',
      saveFailed: 'ブックマークの保存に失敗しました',
      loading: '読み込み中…',
      noBookmarks: 'ブックマークはありません',
      only3DSaveWarning: 'ブックマークは 3D 表示でのみ保存できます',
      viewNotReadyWarning: '現在の表示の準備ができていません。ブックマークを保存できません。',
      only3DApplyWarning: 'ブックマークは 3D 表示でのみ適用できます',
      appliedSuccess: 'ブックマークの表示を適用しました',
      nameMinLength: '名前は 2 文字以上である必要があります',
      nameMaxLength: '名前は 20 文字以内である必要があります'
    },
    layerTree: {
      filterPlaceholder: '名前とタグでフィルタ…',
      layers: 'レイヤー',
      detail: '詳細',
      delete: '削除',
      pointCloudLayers: '点群レイヤー',
      trajectory: "軌跡",
      vectorLayers: 'ベクターレイヤー',
      newPlotLayer: '新規作図レイヤー',
      deletePrompt: '「{name}」を削除してもよろしいですか？'
    },
    share: {
      title: '共有',
      shareLink: '共有リンク',
      encryption: '暗号化',
      copy: 'コピー',
      preview3D: '3D プレビュー',
      advanced: '詳細設定',
      validityPeriod: '有効期限',
      hours24: '24 時間',
      days7: '7 日',
      days14: '14 日',
      customize: 'カスタム',
      hour: '時間',
      day: '日',
      week: '週',
      month: '月',
      application: '適用',
      qrCode: 'QR コード',
      scanQRCode: 'QR コードをスキャン',
      copySuccess: 'リンクをコピーしました',
      copyFailed: 'リンクのコピーに失敗しました',
      browserNotSupport: 'お使いのブラウザはクリップボードをサポートしていません',
      previewMessage: '3D プレビュー機能は green-3d をベースに拡張可能です',
      generatingQRCode: 'QR コードを生成中…'
    },
    cutModel: {
      cropEffect: '切断効果',
      boxInfo: '切り取り範囲',
      highlight: 'ハイライト',
      internal: '内部',
      external: '外部',
      position: '位置',
      scale: 'サイズ',
      rotation: '回転',
      long: '長さ',
      wide: '幅',
      tall: '高さ',
      x: 'X',
      y: 'Y',
      z: 'Z',
      defaultName: '切断 {count}',
      maxLimitReached: '最大切断数（8）に達しました。既存の切断を削除してください。',
      boundsUnavailable: '点群の範囲を取得できません。点群の読み込み完了後に切り取ってください。',
    },
    lineDetails: {
      lineWidth: '線幅',
      color: '色',
      opacity: '不透明度',
      length2d: '2D 長さ',
      length3d: '3D 長さ',
      minElevation: '最小標高',
      maxElevation: '最大標高',
      elevationDiff: '標高差',
      minSlope: '最小傾斜',
      maxSlope: '最大傾斜',
    },
    profileDetails: {
      thickness: '厚さ',
      colorMode: 'カラーモード',
      none: 'なし',
      customColor: 'カスタムカラー',
    },
    polygonDetails: {
      lineWidth: '線幅',
      color: '色',
      opacity: '不透明度',
      length2d: '2D 長さ',
      length3d: '3D 長さ',
      area2d: '2D 面積',
      area3d: '3D 面積',
      perimeter2d: '2D 周長',
      perimeter3d: '3D 周長',
      minElevation: '最小標高',
      maxElevation: '最大標高',
      elevationDiff: '標高差',
      borderColor: '枠線の色',
      fillColor: '塗りつぶしの色',
      slope: '傾斜角',
    },
    pointCloud: {
      metadata: 'メタデータ',
      pointCount: '点数',
      boundingBox: 'バウンディングボックス',
      renderSetting: 'レンダリング設定',
      pointSize: 'ポイントサイズ',
      pointMode: 'ポイントモード',
      pointShape: 'ポイント形状',
      attribute: '属性',
      heightRange: '高さ範囲',
      colorRamp: 'カラーランプ',
      edl: 'EDL（Eye Dome Lighting）',
      rgb: 'RGB',
      elevation: '標高',
      intensity: '強度',
      classification: '分類',
      returnNumber: 'リターン番号',
      pointSourceId: 'ポイントソース ID',
      circle: '円',
      square: '四角',
      paraboloid: '放物面',
      rainbow: 'レインボー',
      viridis: 'Viridis',
      plasma: 'Plasma',
      inferno: 'Inferno',
      magma: 'Magma',
      grayscale: 'グレースケール',
      min: '最小',
      max: '最大',
      type: '種類',
      borderWidth: '枠線の幅',
      borderColor: '枠線の色',
      Easting: '東距',
      size: 'サイズ',
      color: '色',
      attribute: '属性',
      Easting: '東距',
      opacity: '不透明度',
      imageTag: '画像タグ',
      select: '選択',
      iconEmptyTip: 'アイコンがありません。上のアップロードボタンから追加してください。',
      iconDeleteSuccess: 'アイコンを削除しました',
      Northing: '北距',
      Z: 'Z',
      coordinatesWgs84: 'WGS84 座標',
      numberOfReturns: 'リターン数の色',
    }
  }
}
